<template>
  <div class="sidebar-border-style mt-5 px-md-5 py-4">
    <h2 v-html="context.title" class="text-center mb-3 font-weight-bold"></h2>
    <div class="py-3 px-2">
      <div class="row align-items-center mb-3" v-for="(bundleProduct, index) in context.bundleProducts" :key="`bundle-product-${index}`">
        <div class="col col-4">
          <img v-if="bundleProduct.image" class="w-100" style="max-height: 80px; object-fit: contain" :src="getImage(bundleProduct.image.original)" />
        </div>
        <div class="col col-8 align-items-center">
          <span>{{ bundleProduct.title }}</span>
          <div v-if="bundleProduct.retailPrice && bundleProduct.retailPrice > 0">
            <del class="dp-gray-text">{{ $n(bundleProduct.retailPrice, 'currency') }}</del>
            <span class="ml-1 discounted-price font-weight-bold text-dark">
              <span class="sr-only">Price reduced to </span> {{ $n(bundleProduct.discountPrice, 'currency') }}
            </span>
            <span class="ml-1 font-weight-bold light-blue-font">
              (save {{ $n(bundleProduct.savingAmount, 'currency') }})
            </span>
          </div>
          <div v-else>
            <span class="font-weight-bold text-dark" v-text="$t('totals.free')"></span>
          </div>
        </div>
      </div>
    </div>
    <h3 class="text-center text-dark dp-blue-font font-weight-bold">Total price: {{ $n(context.totalPriceLabel, 'currency') }} <span class="light-blue-font font-weight-bold">(SAVE {{ $n(context.totalSavingsLabel, 'currency') }})</span></h3>
    <h4 class="text-center mb-4 font-weight-bold">Was {{ $n(context.originalPriceLabel, 'currency') }}</h4>
    <div class="text-center">
      <b-button
          :disabled="submitDisabled"
          @click="$emit('submit')"
          class="text-center py-lg-3 px-5 w-lg-75 d-inline-block bg-white button-dark-blue-font border-gray font-weight-bold rounded-8px"
      >
        {{ context.buttonText }}
        <div v-if="itemLoading" role="status" class="fa-pulse float-right mt-1">
          <fa-icon :icon="['fas', 'spinner']" class="d-flex" />
          <span class="sr-only">{{ $t('dp.buttons.loading') }}</span>
        </div>
      </b-button>
    </div>
  </div>
</template>

<script>
import getImage from "../mixins/getImage";

export default {
  name: "ProductBundleSidebarElement",
  mixins: [getImage],
  props: {
    context: {
      type: Object,
      default: () => null,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    itemLoading: {
      type: Boolean,
      default: false,
    },
  },
  created: function () {
    this.$emit('bundle-component-created');
  },
}
</script>

<style scoped>

@media (min-width: 992px) {
  .sidebar-border-style {
    border: 5px solid #f0f4ff !important;
    border-radius: 15px;
  }
}

del.dp-gray-text {
  color: #979797 !important;
}

span.light-blue-font {
  color: #0D7BC5 !important;
}

.button-dark-blue-font {
  color: #005C99 !important;
  &:disabled {
    color: white !important;
  }
  &:hover {
    color: white !important;
    background-color: #005C99 !important;
  }
}

h3.dp-blue-font {
  color: #003c71 !important;
}

.border-gray {
  border: 1px solid #979797 !important;
}

.rounded-8px {
  border-radius: 8px !important;
}

.w-lg-75 {
  width: 100% !important;
  @media (min-width: 992px) {
    width: 75% !important;
  }
}
</style>